import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, Globe, Clock, Info, ExternalLink, Check, Settings as SettingsIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SettingsPage() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  // Notification Settings State
  const [notificationScope, setNotificationScope] = useState('account');
  const [gradingWeb, setGradingWeb] = useState(true);
  const [gradingEmail, setGradingEmail] = useState(true);
  const [gradingFrequency, setGradingFrequency] = useState('daily');
  const [updatesWeb, setUpdatesWeb] = useState(true);
  const [updatesEmail, setUpdatesEmail] = useState(false);
  const [updatesFrequency, setUpdatesFrequency] = useState('daily');
  const [activityWeb, setActivityWeb] = useState(true);
  const [activityEmail, setActivityEmail] = useState(true);
  const [activityFrequency, setActivityFrequency] = useState('daily');
  const [newQuestionWeb, setNewQuestionWeb] = useState(false);
  const [newQuestionEmail, setNewQuestionEmail] = useState(false);
  const [newQuestionFrequency, setNewQuestionFrequency] = useState('daily');
  const [newDiscussionWeb, setNewDiscussionWeb] = useState(false);
  const [newDiscussionEmail, setNewDiscussionEmail] = useState(false);
  const [newDiscussionFrequency, setNewDiscussionFrequency] = useState('daily');
  // Site Preferences State
  const [siteLanguage, setSiteLanguage] = useState('English');
  const [timezone, setTimezone] = useState('UTC-5');
  // Linked Accounts State
  const [linkedAccounts, setLinkedAccounts] = useState({
    apple: false,
    facebook: false,
    google: true,
    microsoft: false
  });
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-2551" data-mp="2auywxobljb0q">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-2552" data-mp="25vdswzhkkch5">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2553" data-mp="25wx9ysb1urjz">
          <div className="flex items-center h-16" data-id="element-2554" data-mp="21splmw8i7dma">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-2555" data-mp="1wufsssa94p3u">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-2556" data-mp="1rw4jcinvcgm5">
              <Link to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2557" data-mp="3r8p453y0ifel">
                <Home size={18} data-id="element-2558" data-mp="3max9w39wah78" />
                <span className="hidden sm:inline" data-id="element-2559" data-mp="3m7j4em5xprvk">Admin Hub</span>
              </Link>
              <Link to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2560" data-mp="3tsv5r4z5ltrz">
                <BarChart3 size={18} data-id="element-2561" data-mp="7d0n77ctn4tv" />
                <span className="hidden sm:inline" data-id="element-2562" data-mp="7e2bidiulntj">Analytics</span>
              </Link>
              <Link to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2563" data-mp="cblqxgra86n2">
                <FileText size={18} data-id="element-2564" data-mp="3awn92pk7ir8a" />
                <span className="hidden sm:inline" data-id="element-2565" data-mp="3fskdpym3y958">Reports</span>
              </Link>
              <Link to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2566" data-mp="3krxabb2s6ul0">
                <UserCog size={18} data-id="element-2567" data-mp="3pt4fd2djhfnz" />
                <span className="hidden sm:inline" data-id="element-2568" data-mp="1027vuz5zpasu">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-2569" data-mp="14zznrt6mwwx1">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-2570" data-mp="12m49tj9k6u3p">
                <Bell size={20} data-id="element-2571" data-mp="ylu5eb1f0bqy" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-2572" data-mp="ymvg2eeiqw85"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-2573" data-mp="1cih0s9dpytur">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-2574" data-mp="17kz1zbtf1v0h">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-2575" data-mp="1hkg4jkddfss8">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-2576" data-mp="1qc895efps7ow">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-2577" data-mp="25aaglzpv9dbf" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-2578" data-mp="20bz8btf7zavb">
                    <div className="py-2" data-id="element-2579" data-mp="2jud49pq72ots">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2580" data-mp="2nwrs6o8q0erx">
                        <Users size={18} className="text-gray-600" data-id="element-2581" data-mp="2a0e611t8rp74" />
                        <span className="font-medium text-gray-900" data-id="element-2582" data-mp="2evjt43ydr9ws">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2583" data-mp="24z70l9ekn23m">
                        <Home size={18} className="text-gray-600" data-id="element-2584" data-mp="1r9dbqr32ghtw" />
                        <span className="font-medium text-gray-900" data-id="element-2585" data-mp="1w7olz2x9wucn">
                          Learner Hub
                        </span>
                      </button>
                      <Link to="/admin" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2586" data-mp="1m8fs0a2erfqa">
                        <UserCog size={18} className="text-gray-600" data-id="element-2587" data-mp="135dppagc5zgf" />
                        <span className="font-medium text-gray-900" data-id="element-2588" data-mp="ycubqcdql2b3">
                          Admin Hub
                        </span>
                      </Link>
                      <Link to="/settings" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2589" data-mp="tboga6soz0xv">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2590" data-mp="1m1dl6v8ivl4r">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" data-id="element-2591" data-mp="1c3hdkdesn8be"></path>
                          <circle cx="12" cy="12" r="3" data-id="element-2592" data-mp="2hb0etstdgedu"></circle>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2593" data-mp="2m3abrsswmepm">
                          Settings
                        </span>
                      </Link>
                      <div className="border-t border-gray-200 my-2" data-id="element-2594" data-mp="2v2x29jk3i03w"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2595" data-mp="2v51eqpw287fs">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2596" data-mp="351mkxejtfol7">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-2597" data-mp="1amttlrpytjz2"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-2598" data-mp="3ckm35gvjja2z"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-2599" data-mp="3cistrttjmbra"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2600" data-mp="37jq0f6mxdtz5">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2601" data-mp="2omy9cb156akj">
        {/* Header */}
        <div data-phoebe-tour="settings" className="mb-8" data-id="element-2602" data-mp="2opb27j8fu5cd">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2603" data-mp="33kyzeofc9s6r">Settings</h1>
          <p className="text-gray-600" data-id="element-2604" data-mp="2ykutfsc24fus">
            Manage your notification preferences and account settings
          </p>
        </div>

        <div className="space-y-8" data-id="element-2605" data-mp="is5bp0q86mh2">
          {/* Notifications Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2606" data-mp="du3smfssun5l">
            <div className="p-6 border-b border-gray-200" data-id="element-2607" data-mp="ce85175e70kl">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2608" data-mp="cft0cyzj6nji">
                Notifications
              </h2>
              <div className="text-sm text-gray-600 space-y-2" data-id="element-2609" data-mp="144w48dni9vvm">
                <p data-id="element-2610" data-mp="145fmjvh2ima6">
                  Account-level settings apply to all courses. Notifications for
                  individual courses can be changed within each course and will
                  override account-level settings.
                </p>
                <p data-id="element-2611" data-mp="zdxj90rko9m1">
                  Daily notifications are delivered at 22:00 UTC. Weekly
                  notifications are delivered at 22:00 UTC Every Sunday.
                </p>
                <p className="text-[#30718D]" data-id="element-2612" data-mp="1rugp5237z37j">
                  Notifications for certain activities are enabled by default,{' '}
                  <a href="#" className="underline hover:text-[#265a70]" data-id="element-2613" data-mp="3b3oapyk4dst2">
                    as detailed here
                  </a>
                  <ExternalLink size={12} className="inline ml-1" data-id="element-2614" data-mp="3g29f8a6emynb" />
                </p>
              </div>
            </div>

            <div className="p-6" data-id="element-2615" data-mp="3184ne0jmg2fx">
              {/* Notification Scope Selector */}
              <div className="mb-6" data-id="element-2616" data-mp="366xxrk3m3dbv">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2617" data-mp="2scwxun0xbk9x">
                  Select notifications for
                </label>
                <select value={notificationScope} onChange={e => setNotificationScope(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2618" data-mp="2x5hpbhwcxlaa">
                  <option value="account" data-id="element-2619" data-mp="29e2hj9ltabrn">Account</option>
                  <option value="course1" data-id="element-2620" data-mp="29gp0e5e5kdp6">Course 1</option>
                  <option value="course2" data-id="element-2621" data-mp="2df4ipvzagxw9">Course 2</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2622" data-mp="1urdl5gmuweph">
                  Applies to all courses
                </p>
              </div>

              {/* Notification Settings Table */}
              <div className="space-y-6" data-id="element-2623" data-mp="23sbrw6ooj0br">
                {/* Grading */}
                <div data-id="element-2624" data-mp="23q7carhf4cvn">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2625" data-mp="1ytqmlsuklqgg">
                    Grading
                  </h3>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2626" data-mp="2dpptj05y1kk0">
                    <div className="flex-1" data-id="element-2627" data-mp="28rekgrnh3e2u">
                      <span className="text-sm text-gray-700" data-id="element-2628" data-mp="2mjl08cmprj1r">
                        Essay assignment grade received
                      </span>
                    </div>
                    <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2629" data-mp="2iju3lsaia8pb">
                      <div className="flex items-center gap-2" data-id="element-2630" data-mp="2whimwvoxd7s9">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2631" data-mp="2rj7empea35c5">
                          Web
                        </span>
                        <button onClick={() => setGradingWeb(!gradingWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2632" data-mp="1p2ndao1m1z4i">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2633" data-mp="1y3lk1e3fokqs" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2634" data-mp="2ctjbc2wntqk7">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2635" data-mp="2cw5iw2jjw62f">
                          Email
                        </span>
                        <button onClick={() => setGradingEmail(!gradingEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2636" data-mp="2ltxxf4hg79or">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2637" data-mp="rhhv2errwfp6" />
                        </button>
                      </div>
                      <select value={gradingFrequency} onChange={e => setGradingFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2638" data-mp="f4x9s5zlla1c">
                        <option value="daily" data-id="element-2639" data-mp="12v9p41x6a91y">Daily</option>
                        <option value="weekly" data-id="element-2640" data-mp="xxhpelqadin7">Weekly</option>
                        <option value="immediately" data-id="element-2641" data-mp="xy17c2fxs718">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Updates */}
                <div data-id="element-2642" data-mp="owa0uvdknw6b">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2643" data-mp="3dodzpvtoknrv">
                    Updates
                  </h3>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2644" data-mp="39m962x38fr58">
                    <div className="flex-1" data-id="element-2645" data-mp="11chwnd2sdhco">
                      <span className="text-sm text-gray-700" data-id="element-2646" data-mp="164swkfxj1358">
                        Course updates
                      </span>
                    </div>
                    <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2647" data-mp="rhhnckothv8a">
                      <div className="flex items-center gap-2" data-id="element-2648" data-mp="wg184hrod0z2">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2649" data-mp="1k4tx1u9vq8k6">
                          Web
                        </span>
                        <button onClick={() => setUpdatesWeb(!updatesWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2650" data-mp="1p2canxyudbyi">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2651" data-mp="1f3wirsrzpyny" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2652" data-mp="3sc761i05wxrg">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2653" data-mp="3sambvthrfgu4">
                          Email
                        </span>
                        <button onClick={() => setUpdatesEmail(!updatesEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2654" data-mp="64pfd5f577w2">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2655" data-mp="39kwinatnb34b" />
                        </button>
                      </div>
                      <select value={updatesFrequency} onChange={e => setUpdatesFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2656" data-mp="3jd26q9gs10e8">
                        <option value="daily" data-id="element-2657" data-mp="2lwdcp1y2j2fe">Daily</option>
                        <option value="weekly" data-id="element-2658" data-mp="2lu0uqosb8s2c">Weekly</option>
                        <option value="immediately" data-id="element-2659" data-mp="3bj7n9wb0z50h">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Discussions */}
                <div data-id="element-2660" data-mp="3kdvrdj4v6gnp">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2661" data-mp="3kdchmppdaykr">
                    Discussions
                  </h3>
                  <div className="space-y-3" data-id="element-2662" data-mp="2slekqv4bcx3m">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2663" data-mp="2smpwpi7wxb5t">
                      <div className="flex-1 flex items-center gap-2" data-id="element-2664" data-mp="2wp2tvi8lg0qz">
                        <span className="text-sm text-gray-700" data-id="element-2665" data-mp="31ki2nvrqv6gj">
                          Activity notifications
                        </span>
                        <Info size={14} className="text-gray-400" data-id="element-2666" data-mp="gvuciq0zc5o1" />
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2667" data-mp="luylbfjzs1du">
                        <div className="flex items-center gap-2" data-id="element-2668" data-mp="lx1hyifngsrj">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2669" data-mp="26boapkqzyciq">
                            Web
                          </span>
                          <button onClick={() => setActivityWeb(!activityWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2670" data-mp="1wn6b36ugebgo">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2671" data-mp="1nn15914wrl4m" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2672" data-mp="1dou1xl3jl1l3">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2673" data-mp="18q0nnqgfl6jv">
                            Email
                          </span>
                          <button onClick={() => setActivityEmail(!activityEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2674" data-mp="3808t86c7b92y">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2675" data-mp="2gwzdcmo7pzam" />
                          </button>
                        </div>
                        <select value={activityFrequency} onChange={e => setActivityFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2676" data-mp="2764i4ssznpd1">
                          <option value="daily" data-id="element-2677" data-mp="1k6q5ge14nh9o">Daily</option>
                          <option value="weekly" data-id="element-2678" data-mp="1k8b003nfz07j">Weekly</option>
                          <option value="immediately" data-id="element-2679" data-mp="1o7jsl56qws1i">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2680" data-mp="3eiwsca3dvmht">
                      <div className="flex-1" data-id="element-2681" data-mp="16yhk3afaa6p3">
                        <span className="text-sm text-gray-700" data-id="element-2682" data-mp="16z92fjjve7xf">
                          New question posts
                        </span>
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2683" data-mp="1gpu9zwhiumsh">
                        <div className="flex items-center gap-2" data-id="element-2684" data-mp="1bxkgy7l416lz">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2685" data-mp="1bw98vvkmtcp2">
                            Web
                          </span>
                          <button onClick={() => setNewQuestionWeb(!newQuestionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2686" data-mp="1lmu7vk47wj8i">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2687" data-mp="1upd5npt5c5nw" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2688" data-mp="34r7xjz470h5p">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2689" data-mp="34pd9ibxmk8xe">
                            Email
                          </span>
                          <button onClick={() => setNewQuestionEmail(!newQuestionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2690" data-mp="3dk1f63743smq">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2691" data-mp="2lt5a3oramsa0" />
                          </button>
                        </div>
                        <select value={newQuestionFrequency} onChange={e => setNewQuestionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2692" data-mp="2pugt3bfnwf98">
                          <option value="daily" data-id="element-2693" data-mp="53q54zhi6h1g">Daily</option>
                          <option value="weekly" data-id="element-2694" data-mp="dkqo3r0fp6id">Weekly</option>
                          <option value="immediately" data-id="element-2695" data-mp="hmlpswma1lwo">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 gap-3" data-id="element-2696" data-mp="3odm85uqjmcj">
                      <div className="flex-1" data-id="element-2697" data-mp="8m5qlzckh0xm">
                        <span className="text-sm text-gray-700" data-id="element-2698" data-mp="waydl6b7nyg3">
                          New discussion posts
                        </span>
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2699" data-mp="11cdzt1p4kb02">
                        <div className="flex items-center gap-2" data-id="element-2700" data-mp="mlevi2vbo8ma">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2701" data-mp="rjq4kbdsmf3g">
                            Web
                          </span>
                          <button onClick={() => setNewDiscussionWeb(!newDiscussionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2702" data-mp="1f8j1ob65iszn">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2703" data-mp="1oxgcrsyyw26l" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2704" data-mp="1fx08ihaegr0o">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2705" data-mp="1aygownja3rbh">
                            Email
                          </span>
                          <button onClick={() => setNewDiscussionEmail(!newDiscussionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2706" data-mp="165ngnpolq0un">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2707" data-mp="s87bsilyef50" />
                          </button>
                        </div>
                        <select value={newDiscussionFrequency} onChange={e => setNewDiscussionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2708" data-mp="2yvofngixvllw">
                          <option value="daily" data-id="element-2709" data-mp="3cuo1yhizboew">Daily</option>
                          <option value="weekly" data-id="element-2710" data-mp="2g5gidf1x7pdm">Weekly</option>
                          <option value="immediately" data-id="element-2711" data-mp="2g7b24q1ghbg4">Immediately</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Site Preferences Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2712" data-mp="2ty63lh9mkq9o">
            <div className="p-6 border-b border-gray-200" data-id="element-2713" data-mp="7ywfqr6opnny">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2714" data-mp="2yqhgs5wt2ww">
                Site Preferences
              </h2>
            </div>

            <div className="p-6 space-y-6" data-id="element-2715" data-mp="gr6ricx8a17b">
              {/* Site Language */}
              <div data-id="element-2716" data-mp="bywsm7e4xqsw">
                <div className="flex items-center gap-2 mb-2" data-id="element-2717" data-mp="bydl7km42kt4">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2718" data-mp="qo2rfu929f09">
                    Site language
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2719" data-mp="lo6olyc3ntma">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2720" data-mp="zpj305bm3n62">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2721" data-mp="vo793nlpgfs2"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2722" data-mp="31gnsauq2obn8"></path>
                    </svg>
                  </button>
                </div>
                <select value={siteLanguage} onChange={e => setSiteLanguage(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2723" data-mp="2nalw260uny4h">
                  <option value="English" data-id="element-2724" data-mp="2dksix0l27ay4">English</option>
                  <option value="Spanish" data-id="element-2725" data-mp="2ijc3oxnx2gow">Español</option>
                  <option value="French" data-id="element-2726" data-mp="2ihsnt866a7nn">Français</option>
                  <option value="German" data-id="element-2727" data-mp="23m3b60mvn6vl">Deutsch</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2728" data-mp="28m7r9pjvhzla">
                  The language used throughout this site. This site is currently
                  available in a limited number of languages.
                </p>
              </div>

              {/* Time Zone */}
              <div data-id="element-2729" data-mp="3p07napfll539">
                <div className="flex items-center gap-2 mb-2" data-id="element-2730" data-mp="3ozxy342dn1ym">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2731" data-mp="3oyd5vl3jbv3x">
                    Time zone
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2732" data-mp="3rl5ffmvhbr02">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2733" data-mp="3nj21mrlc8abm">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2734" data-mp="3ikqpga7klnq8"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2735" data-mp="3dm60x81okshm"></path>
                    </svg>
                  </button>
                </div>
                <button className="text-[#30718D] text-sm font-medium hover:text-[#265a70] mb-2" data-id="element-2736" data-mp="a4dz71xqsu68">
                  Set time zone
                </button>
                <p className="text-xs text-gray-500" data-id="element-2737" data-mp="5bkzwtl1me1j">
                  Select the time zone for displaying course dates. If you do
                  not specify a time zone, course dates, including assignment
                  deadlines, will be displayed in your browser's local time
                  zone.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Linked Accounts Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2738" data-mp="15d9cfvxkfw9m">
            <div className="p-6 border-b border-gray-200" data-id="element-2739" data-mp="1fcqbhuibbbwm">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2740" data-mp="1jdscogvshy18">
                Linked Accounts
              </h2>
              <p className="text-sm text-gray-600" data-id="element-2741" data-mp="1oasjwv4dl6tx">
                You can link your identity accounts to simplify signing in to
                edX.
              </p>
            </div>

            <div className="p-6 space-y-4" data-id="element-2742" data-mp="1y0vdawfesmss">
              {/* Apple */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2743" data-mp="231jeuc19km19">
                <div data-id="element-2744" data-mp="272blqymnyeud">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2745" data-mp="273ms967hu0p6">
                    Apple
                  </div>
                  {linkedAccounts.apple && <div className="text-xs text-gray-500" data-id="element-2746" data-mp="2sfeafiapaed0">
                      Linked account: user@icloud.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                apple: !linkedAccounts.apple
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2747" data-mp="32aen8knvoim5">
                  {linkedAccounts.apple ? 'Unlink' : 'Sign in with Apple'}
                </button>
              </div>

              {/* Facebook */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2748" data-mp="2je6ev7zkjrmm">
                <div data-id="element-2749" data-mp="2eku15swfh58n">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2750" data-mp="1qwkjn368z3nb">
                    Facebook
                  </div>
                  {linkedAccounts.facebook && <div className="text-xs text-gray-500" data-id="element-2751" data-mp="1lwobcrqioq1y">
                      Linked account: user@facebook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                facebook: !linkedAccounts.facebook
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2752" data-mp="66owsfapj9z5">
                  {linkedAccounts.facebook ? 'Unlink' : 'Sign in with Facebook'}
                </button>
              </div>

              {/* Google */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2753" data-mp="p3q446rqhm69">
                <div data-id="element-2754" data-mp="b4gmd2nvqk06">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2755" data-mp="b4yt4t864gmc">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-2756" data-mp="g3a2l2ujwp41">
                      Google
                    </span>
                    <span className="px-2 py-0.5 bg-[#007558]/10 text-[#007558] text-xs font-medium rounded" data-id="element-2757" data-mp="2vu61zhweq9tx">
                      Linked
                    </span>
                  </div>
                  {linkedAccounts.google && <div className="text-xs text-gray-500" data-id="element-2758" data-mp="1yzofvmqwe7at">
                      Linked account: linda.taylor@gmail.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                google: !linkedAccounts.google
              })} className="px-4 py-2 text-[#30718D] hover:bg-[#30718D]/10 rounded-lg text-sm font-medium transition-colors" data-id="element-2759" data-mp="28wt1nlgu00r3">
                  Unlink Google account
                </button>
              </div>

              {/* Microsoft */}
              <div className="flex items-center justify-between py-3" data-id="element-2760" data-mp="1p6fy68f27tha">
                <div data-id="element-2761" data-mp="1txz5887l7vn9">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2762" data-mp="1tz942zm9l7uy">
                    Microsoft
                  </div>
                  {linkedAccounts.microsoft && <div className="text-xs text-gray-500" data-id="element-2763" data-mp="11hws7zjhfssd">
                      Linked account: user@outlook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                microsoft: !linkedAccounts.microsoft
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2764" data-mp="txvmgt9k1sbz">
                  {linkedAccounts.microsoft ? 'Unlink' : 'Sign in with Microsoft'}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}